/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusBuyerDto } from './NovitusBuyerDto';
import {
    NovitusBuyerDtoFromJSON,
    NovitusBuyerDtoFromJSONTyped,
    NovitusBuyerDtoToJSON,
} from './NovitusBuyerDto';
import type { NovitusDeviceControlDto } from './NovitusDeviceControlDto';
import {
    NovitusDeviceControlDtoFromJSON,
    NovitusDeviceControlDtoFromJSONTyped,
    NovitusDeviceControlDtoToJSON,
} from './NovitusDeviceControlDto';
import type { NovitusSystemInfoDto } from './NovitusSystemInfoDto';
import {
    NovitusSystemInfoDtoFromJSON,
    NovitusSystemInfoDtoFromJSONTyped,
    NovitusSystemInfoDtoToJSON,
} from './NovitusSystemInfoDto';
import type { NovitusItemDto } from './NovitusItemDto';
import {
    NovitusItemDtoFromJSON,
    NovitusItemDtoFromJSONTyped,
    NovitusItemDtoToJSON,
} from './NovitusItemDto';
import type { NovitusPaymentDto } from './NovitusPaymentDto';
import {
    NovitusPaymentDtoFromJSON,
    NovitusPaymentDtoFromJSONTyped,
    NovitusPaymentDtoToJSON,
} from './NovitusPaymentDto';
import type { NovitusSummaryDto } from './NovitusSummaryDto';
import {
    NovitusSummaryDtoFromJSON,
    NovitusSummaryDtoFromJSONTyped,
    NovitusSummaryDtoToJSON,
} from './NovitusSummaryDto';
import type { NovitusPrintoutLineDto } from './NovitusPrintoutLineDto';
import {
    NovitusPrintoutLineDtoFromJSON,
    NovitusPrintoutLineDtoFromJSONTyped,
    NovitusPrintoutLineDtoToJSON,
} from './NovitusPrintoutLineDto';

/**
 * 
 * @export
 * @interface NovitusReceiptDto
 */
export interface NovitusReceiptDto {
    /**
     * Tablica pozycji na dokumencie
     * @type {Array<NovitusItemDto>}
     * @memberof NovitusReceiptDto
     */
    items?: Array<NovitusItemDto>;
    /**
     * Tablica metod płatności używanych dla paragonu (1-16 elementów)
     * @type {Array<NovitusPaymentDto>}
     * @memberof NovitusReceiptDto
     */
    payments?: Array<NovitusPaymentDto>;
    /**
     * Podsumowanie paragonu z sumami
     * @type {NovitusSummaryDto}
     * @memberof NovitusReceiptDto
     */
    summary: NovitusSummaryDto;
    /**
     * Linie wydruku
     * @type {Array<NovitusPrintoutLineDto>}
     * @memberof NovitusReceiptDto
     */
    printout_lines?: Array<NovitusPrintoutLineDto>;
    /**
     * Informacje o nabywcy (opcjonalnie dla paragonów - klienci bez karty)
     * @type {NovitusBuyerDto}
     * @memberof NovitusReceiptDto
     */
    buyer?: NovitusBuyerDto;
    /**
     * Informacje systemowe
     * @type {NovitusSystemInfoDto}
     * @memberof NovitusReceiptDto
     */
    system_info?: NovitusSystemInfoDto;
    /**
     * Ustawienia sterowania urządzeniem
     * @type {NovitusDeviceControlDto}
     * @memberof NovitusReceiptDto
     */
    device_control?: NovitusDeviceControlDto;
}

/**
 * Check if a given object implements the NovitusReceiptDto interface.
 */
export function instanceOfNovitusReceiptDto(value: object): value is NovitusReceiptDto {
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function NovitusReceiptDtoFromJSON(json: any): NovitusReceiptDto {
    return NovitusReceiptDtoFromJSONTyped(json, false);
}

export function NovitusReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusReceiptDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(NovitusItemDtoFromJSON)),
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(NovitusPaymentDtoFromJSON)),
        'summary': NovitusSummaryDtoFromJSON(json['summary']),
        'printout_lines': json['printout_lines'] == null ? undefined : ((json['printout_lines'] as Array<any>).map(NovitusPrintoutLineDtoFromJSON)),
        'buyer': json['buyer'] == null ? undefined : NovitusBuyerDtoFromJSON(json['buyer']),
        'system_info': json['system_info'] == null ? undefined : NovitusSystemInfoDtoFromJSON(json['system_info']),
        'device_control': json['device_control'] == null ? undefined : NovitusDeviceControlDtoFromJSON(json['device_control']),
    };
}

export function NovitusReceiptDtoToJSON(value?: NovitusReceiptDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(NovitusItemDtoToJSON)),
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(NovitusPaymentDtoToJSON)),
        'summary': NovitusSummaryDtoToJSON(value['summary']),
        'printout_lines': value['printout_lines'] == null ? undefined : ((value['printout_lines'] as Array<any>).map(NovitusPrintoutLineDtoToJSON)),
        'buyer': NovitusBuyerDtoToJSON(value['buyer']),
        'system_info': NovitusSystemInfoDtoToJSON(value['system_info']),
        'device_control': NovitusDeviceControlDtoToJSON(value['device_control']),
    };
}

